import { useHeader } from "../../contexts/PageHeaderContext";
import { isNullOrEmpty } from "../../utils/helper";
import "./PageHeader.scss";

interface PageHeaderProps {
  inverse: boolean;
  isHomeScreen: boolean;
}

const PageHeader = (props: PageHeaderProps) => {
  const { inverse, isHomeScreen } = props;
  const { header } = useHeader();
  const { secondHeader } = useHeader();

  return !isHomeScreen ? (
    <div
      data-testid="main-content-header"
      className={
        inverse ? "main-content-header-inverse" : "main-content-header"
      }
    >
      <div
        className={
          inverse
            ? "main-content-header-inverse-text"
            : "main-content-header-text"
        }
      >
        <div className="main-content-header-no-overflow">{header}</div>
      </div>
      {!isNullOrEmpty(secondHeader) && (
        <div className="main-content-header-second">
          <div className="main-content-header-second-text main-content-header-no-overflow">
            {secondHeader}
          </div>
        </div>
      )}
    </div>
  ) : (
    <></>
  );
};

export default PageHeader;
